import { Fragment } from "react";
import { workflowSteps } from "../data/products";
import { ProductGlyph } from "./ProductGlyph";

interface WorkflowProps {
  compact?: boolean;
}

export function Workflow({ compact = false }: WorkflowProps) {
  return (
    <div className={`workflow ${compact ? "workflow--compact" : ""}`}>
      <div className="workflow-track">
        {workflowSteps.map((step, index) => (
          <Fragment key={step.type}>
            <article
              className={`workflow-step workflow-step--${step.type}`}
              data-step={step.code}
            >
              <div className="workflow-step__head">
                <span>{step.status}</span>
              </div>
              <div className="workflow-step__body">
                <div className="workflow-step__icon">
                  <ProductGlyph type={step.type} theme="light" />
                </div>
                <div className="workflow-step__copy">
                  <span>{step.product}</span>
                  <strong>{step.title}</strong>
                  <p>{step.description}</p>
                </div>
              </div>
              <div className="workflow-step__exchange">
                <span>{step.input}</span>
                <i>→</i>
                <strong>{step.output}</strong>
              </div>
            </article>
            {index < workflowSteps.length - 1 ? (
              <div className="workflow-connector" aria-hidden="true">
                <span></span>
                <i></i>
              </div>
            ) : null}
          </Fragment>
        ))}
      </div>
      <div className="workflow-assistant">
        <div className="workflow-assistant__icon">
          <ProductGlyph type="jia" />
        </div>
        <div>
          <span>日常专业工作支持</span>
          <strong>小加+ · 财税专业 AI 助手</strong>
          <p>帮助团队检索准则法规、整理机构资料并辅助起草专业文档</p>
        </div>
        <div className="workflow-assistant__points">
          <span>专业知识</span>
          <span>机构资料</span>
          <span>文档辅助</span>
        </div>
      </div>
    </div>
  );
}
